export const visit = (vm, at) => {
at({ "es": { "priceComponents": { "pricePerMonth": "{{price}}/mes", "pricePerMonthPerSeat": "{{price}}/mes/licencia", "pricingLabel": "Precios de {{name}}", "subtexts": { "startsAt": "Desde" } } } });
};